import React from "react";
import styled from "styled-components";
import LeadMagnetForm from "./LeadMagnetForm";
import {
  GlassPanel,
  SectionHeading,
  SectionKicker,
  SectionLead,
} from "../styles/contentPage";
import { areLeadMagnetsEnabled } from "../lib/leadMagnetVisibility";

export default function LeadMagnetSection({ data, pageKey }) {
  if (!data?.key || !areLeadMagnetsEnabled()) return null;

  const bullets = Array.isArray(data.bullets) ? data.bullets : [];

  return (
    <LeadMagnetPanel
      data-track-section="true"
      data-section-id={`lead-magnet-${data.key}`}
      data-section-title={data.heading}
      data-lead-magnet-section={data.key}
      data-lead-magnet-route={pageKey}
      data-lead-magnet-niche={data.key}
    >
      <LeadMagnetCopy>
        <SectionKicker>{data.kicker}</SectionKicker>
        <SectionHeading>{data.heading}</SectionHeading>
        <SectionLead>{data.lead}</SectionLead>

        <BenefitList>
          {bullets.map((item) => (
            <BenefitItem key={item}>
              <BenefitMark aria-hidden="true" data-lead-magnet-dot />
              <span>{item}</span>
            </BenefitItem>
          ))}
        </BenefitList>
      </LeadMagnetCopy>

      <LeadMagnetForm
        copy={data.form}
        niche={data.key}
        downloadUrl={data.downloadUrl}
        asset={{
          key: data.key,
          title: data.heading,
          route: pageKey,
        }}
      />
    </LeadMagnetPanel>
  );
}

const LeadMagnetPanel = styled(GlassPanel)`
  display: grid;
  grid-template-columns: minmax(0, 1.08fr) minmax(320px, 0.72fr);
  gap: clamp(24px, 4vw, 56px);
  align-items: stretch;
  padding: clamp(24px, 4vw, 48px);
  border-radius: 36px;

  @media (max-width: 980px) {
    grid-template-columns: 1fr;
  }
`;

const LeadMagnetCopy = styled.div`
  display: grid;
  align-content: start;
  gap: 18px;
`;

const BenefitList = styled.ul`
  display: grid;
  gap: 12px;
  padding: 0;
  margin: 8px 0 0;
  list-style: none;
`;

const BenefitItem = styled.li`
  display: grid;
  grid-template-columns: 16px minmax(0, 1fr);
  gap: 12px;
  align-items: start;
  color: rgba(255, 255, 255, 0.78);
  font-size: 16px;
  line-height: 1.6;
`;

const BenefitMark = styled.span`
  width: 8px;
  height: 8px;
  margin-top: 8px;
  border-radius: 999px;
  background: rgba(126, 202, 221, 0.92);
  box-shadow: 0 0 18px rgba(126, 202, 221, 0.48);
`;
